if (document.readyState !== 'loading') {
    initialiseAllCarousels()
} else {
  document.addEventListener('DOMContentLoaded', function(event) {
    initialiseAllCarousels()
  });
}

function initCarousel(carouselElement) {
  const track = carouselElement.querySelector('.carousel__track');
  // const slides = Array.from(track.children);
  let carouselContainer;
  if(Boolean(carouselElement.closest('.lookbook-mobile__content'))) {
    carouselContainer = carouselElement.closest('.lookbook-mobile__content-pane');
  }
  else if(Boolean(carouselElement.closest('.stl-images-container'))) {
    carouselContainer = carouselElement.closest('.stl-images-container');
  }
  let slides = Array.from(carouselElement.querySelectorAll('.carousel__slide'));
  let nav = carouselContainer.querySelector('.carousel__nav');
  let dots = Array.from(nav.children);
  let index = carouselContainer.querySelector('.carousel__index');

  // Update the active dot and the visible slide
  const updateActiveSlide = (currentSlide) => {
    let currentDot = dots.find(dot => dot.classList.contains('active'));
    if (currentDot) { 
      currentDot.classList.remove('active');
    }

    let newActiveDot = dots[slides.indexOf(currentSlide)];
    newActiveDot.classList.add('active');

    // Update index indicator
    index.textContent = `${slides.indexOf(currentSlide) + 1}/${slides.length}`;
  }

  // Initialize index indicator
  index.textContent = `1/${slides.length}`;

  const getScrollAmount = (targetSlide) => {
    return slides.slice(0, slides.indexOf(targetSlide)).reduce((totalWidth, slide) => totalWidth + slide.clientWidth, 0);
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId= setTimeout(function(){
        method();
    }, delay);
  }

  // Listen for scroll events on the track
  
  let overflowContainer = carouselElement;
  overflowContainer.addEventListener('scroll', () => {
    debounce(handleScroll, 28);
  });

  function handleScroll() {
    console.log('scrolled');
    const currentSlide = slides.find(slide => {
      const slideLeft = slide.getBoundingClientRect().left;
      const trackLeft = overflowContainer.getBoundingClientRect().left;
      return slideLeft >= trackLeft;
    });
    console.log("current slide:", currentSlide);

    if (currentSlide) {
      updateActiveSlide(currentSlide);
    }
  }

  // Listen for clicks on the dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const targetSlide = slides[index];
      // targetSlide.scrollIntoView({behavior: 'smooth', block:'nearest', inline: 'start'});
      const scrollAmount = getScrollAmount(targetSlide);
      overflowContainer.scrollLeft = scrollAmount;
      updateActiveSlide(targetSlide);
    });
  });

  let rightArrow = carouselContainer.querySelector('.carousel__arrow-right');
  let clickListenerAdded = false;
  if(rightArrow) {
    clickListenerAdded = rightArrow.classList.contains('initialised');
  }
  if(rightArrow && !clickListenerAdded) {
    rightArrow.addEventListener('click', () => {
      // Find the current active slide
      const currentSlideIndex = slides.findIndex(slide => {
          const slideLeft = slide.getBoundingClientRect().left;
          const trackLeft = overflowContainer.getBoundingClientRect().left;
          return slideLeft === trackLeft;
      });

      // Determine the next slide
      const nextSlideIndex = (currentSlideIndex + 1) % slides.length;
      const targetSlide = slides[nextSlideIndex];
      const scrollAmount = getScrollAmount(targetSlide);
      overflowContainer.scrollLeft = scrollAmount;
      updateActiveSlide(targetSlide);
    });
    rightArrow.classList.add('initialised');
  }

  // Hide carousel nav if less than 3 products
  if(Boolean(carouselElement.closest('.lookbook-mobile__content'))) {
    if(dots.length < 3) {
      nav.style.display = 'none';
      index.style.display = 'none';
      carouselContainer.querySelector('.carousel__slide--placeholder').style.display = 'none';
    }
  }

}

function initialiseAllCarousels() {
  const carousels = document.querySelectorAll('.carousel');
  for(let i = 0; i < carousels.length; i++) {
    initCarousel(carousels[i]);
  }
}